module.exports = __webpack_public_path__ + "img/checked-green.ec0393b1.svg";